// extracted by mini-css-extract-plugin
export default {"container":"IndexBanner_container__wVlM7","image":"IndexBanner_image__HQnAr"};